import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { FiX } from "react-icons/fi";

// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
color:#2B3497
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  margin-top:10px;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const Label = styled.label`
  display: flex;
  align-items: center;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin: 10px 20px;
  font-weight: 600;
  &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 150px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

const AddEmpTypePage = () => {
    const [showInput, setShowInput] = useState(false);
    const [locationName, setLocationName] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [isDefault, setIsDefault] = useState(false);

    const [locations, setLocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPagination, setShowPagination] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');

    const [locationNameUpdate, setLocationNameUpdate] = useState('');
    const [isActiveUpdate, setIsActiveUpdate] = useState(false);
    const [isDefaultUpdate, setIsDefaultUpdate] = useState(false);

    // Sort function


    const rowsPerPage = 7;

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axios.get('/EmployeeType');
                if (response.data) {
                    // Assuming the API returns an array of locations
                    setLocations(response.data);
                    setShowPagination(true); // Show pagination after submitting at least one row

                } else {
                    setLocations([]); // Ensure locations is always an array
                }
            } catch (error) {
                console.error('Error fetching Employee Type :', error);
                setLocations([]); // Ensure locations is always an array even if the request fails
            }
        };

        fetchLocations();
    }, []);
    const sortData = (data, column, direction) => {
        const sortedData = [...data].sort((a, b) => {
            if (direction === 'asc') {
                return a[column] > b[column] ? 1 : -1;
            } else {
                return a[column] < b[column] ? 1 : -1;
            }
        });
        return sortedData;
    };

    const handleSort = (column) => {
        const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortColumn(column);
        setSortDirection(direction);
        const sortedData = sortData(locations, column, direction);
        setLocations(sortedData);
    };

    const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

    const handleAddLocationClick = () => {
        setIsPopupVisibleCreate(true);
    };



    const handleLocationSubmit = async () => {
        if (!locationName.trim()) {
            toast.error("Employee Type cannot be empty.");
            return;
        }
        const data = {
            locationName,
            isActive,
            isDefault,
        };
        console.log("Submitting Data:", data);
        try {
            // Prepare the request body
            const requestBody = {
                type: locationName, // the input locationName
                isActive: isActive, // or set this based on your form logic
                isDefault: isDefault,
                createdBy: "string",
                modifiedBy: "string",
                createdOn: new Date().toISOString(), // current date and time
                modifiedOn: new Date().toISOString() // current date and time
            };

            // Make the POST request
            const response = await axios.post('/EmployeeType', requestBody);
            console.log("response", response);
            if (response.data == "EmployeeType already Exists..") {
                toast.warn("Employee Type  already Exists..")
                handleReset();

                return
            }
            if (response.data == "Duplicate defaults are not allowed") {
                toast.error("Duplicate defaults are not allowed")
                handleReset();

                return
            }
            if (response.data == "Saved Successfully.. ") {
                toast.success("Employee Type  Saved Successfully.. ")
                handleReset();
                setIsPopupVisibleCreate(false);
                const fetchLocations = async () => {
                    try {
                        const response = await axios.get('/EmployeeType');
                        if (response.data) {
                            // Assuming the API returns an array of locations
                            setLocations(response.data);
                            setShowPagination(true); // Show pagination after submitting at least one row

                        } else {
                            setLocations([]); // Ensure locations is always an array
                        }
                    } catch (error) {
                        console.error('Error fetching Employee Type :', error);
                        setLocations([]); // Ensure locations is always an array even if the request fails
                    }
                };

                fetchLocations();
                return
            }




        } catch (error) {
            console.error('Error adding Gate:', error);
            toast.error('Error adding Gate');
        }

    };
    const handleSubmitUpdate = async () => {
        if (!locationNameUpdate || locationNameUpdate.trim() === "") {
            toast.error("Employee Type  field cannot be empty.");
            return;
        }



        const data = {
            locationNameUpdate,
            isActiveUpdate,
            isDefaultUpdate,
        };
        console.log("Submitting Data:", data);
        try {
            // Prepare the request body
            const requestBody = {
                id: popupData.id,
                type: locationNameUpdate, // the input locationName
                isActive: isActiveUpdate, // or set this based on your form logic
                isDefault: isDefaultUpdate,
                createdBy: "string",
                modifiedBy: "string",
                createdOn: new Date().toISOString(), // current date and time
                modifiedOn: new Date().toISOString() // current date and time
            };

            // Make the POST request
            const response = await axios.put('/EmployeeType', requestBody);
            console.log("response", response);
            if (response.data == "EmployeeType already Exists..") {
                toast.warn("Employee Type already Exists..")
                return
            }
            if (response.data == "Duplicate defaults are not allowed") {
                toast.error("Duplicate defaults are not allowed")
                return
            }
            if (response.data == "Updated") {
                toast.success("Employee Type Updated Successfully.. ")
                handleReset();
                const fetchLocations = async () => {
                    try {
                        const response = await axios.get('/EmployeeType');
                        if (response.data) {
                            // Assuming the API returns an array of locations
                            setLocations(response.data);
                            setShowPagination(true); // Show pagination after submitting at least one row

                        } else {
                            setLocations([]); // Ensure locations is always an array
                        }
                    } catch (error) {
                        console.error('Error fetching Employee Type :', error);
                        setLocations([]); // Ensure locations is always an array even if the request fails
                    }
                };

                fetchLocations();
                setIsPopupVisible(false);
                return
            }
            if (response.data == "Deleted") {
                toast.success("Employee Type Updated Successfully.. ")
                handleReset();
                const fetchLocations = async () => {
                    try {
                        const response = await axios.get('/EmployeeType');
                        if (response.data) {
                            // Assuming the API returns an array of locations
                            setLocations(response.data);
                            setShowPagination(true); // Show pagination after submitting at least one row

                        } else {
                            setLocations([]); // Ensure locations is always an array
                        }
                    } catch (error) {
                        console.error('Error fetching Employee Type :', error);
                        setLocations([]); // Ensure locations is always an array even if the request fails
                    }
                };

                fetchLocations();
                setIsPopupVisible(false);
                return
            }




        } catch (error) {
            console.error('Error adding Gate:', error);
            toast.error('Error adding Gate');
        }

    };
    const handleEdit = (location) => {
        console.log("location Data", location);
        setLocationNameUpdate(location.type)
        setIsActiveUpdate(location.isActive || false);
        setIsDefaultUpdate(location.isDefault || false);

        setPopupData(location)
        setIsPopupVisible(true);


    }
    const handleDelete = (data) => {
        confirmAlert({
            title: <span style={{ color: '#dc3545' }}>Warning</span>,
            message: 'Are you sure you want to delete this Employee Type ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        try {
                            // Sending the PUT request to mark the location as deleted
                            await axios.put('/EmployeeType/DeleteEmployeeType', {

                                id: data.id,
                                type: data.type, // the input locationName
                                nationalityCode: data.nationalityCode, // or set this dynamically if required
                                isActive: data.isActive, // or set this based on your form logic
                                isDefault: data.isDefault,
                                createdBy: "string",
                                modifiedBy: "string",
                                createdOn: new Date().toISOString(), // current date and time
                                modifiedOn: new Date().toISOString()
                            });

                            // Update the local state to remove the deleted location from the UI
                            const fetchLocations = async () => {
                                try {
                                    const response = await axios.get('/EmployeeType');
                                    if (response.data) {
                                        // Assuming the API returns an array of locations
                                        setLocations(response.data);
                                        setShowPagination(true); // Show pagination after submitting at least one row

                                    } else {
                                        setLocations([]); // Ensure locations is always an array
                                    }
                                } catch (error) {
                                    console.error('Error fetching locations:', error);
                                    setLocations([]); // Ensure locations is always an array even if the request fails
                                }
                            };

                            fetchLocations();

                            // Show success toast message
                            toast.success('Employee Type Deleted Successfully');
                        } catch (error) {
                            console.error('Error deleting Employee Type :', error);
                            // Show error toast message
                            toast.error('Failed to Delete Employee Type ');
                        }
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        // Close dialog without taking any action
                    }
                }
            ]
        });
    };


    const handleReset = () => {
        setSearchTerm('');
        setLocationName('');
        setIsActive(false);
        setIsDefault(false);
        setCurrentPage(1); // Reset pagination to the first page

    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

      const filteredLocations = locations.filter(location => {
        const name = location.type || ''; // Ensure a default value if locationName is null or undefined
        return name.toLowerCase().includes(searchTerm?.toLowerCase() ?? '');
    });



    // Pagination logic
    const itemsPerPage = 7;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredLocations.slice(indexOfFirstItem, indexOfLastItem);




    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const totalPages = Math.ceil(filteredLocations.length / rowsPerPage);

    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const currentRows = filteredLocations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState('');

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    return (
        <Container>
            <Header>
                <Heading>Add Employee Type</Heading>
                <SearchBox>
                    <SearchIcon size={20} />
                    <SearchInput
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </SearchBox>
            </Header>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button className="add-location" onClick={handleAddLocationClick}>
                        Add Employee Type <FiPlus size={20} />
                    </Button>
                    {/* {showInput && (
                        <>
                            <LocationInput
                                type="text"
                                placeholder="Enter Employee type"
                                value={locationName}
                                onChange={(e) => setLocationName(e.target.value)}
                            />
                            <Label>
                                <input
                                    type="checkbox"
                                    checked={isActive}
                                    onChange={() => setIsActive(!isActive)}
                                />
                                Active
                            </Label>
                            <Label>
                                <input
                                    type="checkbox"
                                    checked={isDefault}
                                    onChange={() => setIsDefault(!isDefault)}
                                />
                                Default
                            </Label>
                        </>

                    )} */}

                </div>
                {/* <ButtonGroup>
                    <Button className="reset" onClick={handleReset}>
                        Reset
                    </Button>
                    <Button className="submit" onClick={handleLocationSubmit}>
                        Submit
                    </Button>
                </ButtonGroup> */}
            </Card>
            <TableContainer>
                <StyledTable>
                    <thead>
                        <tr>
                            <TableHeader colSpan={'6'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Employee Type Details</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeader>

                        </tr>
                    </thead>
                    {isExpanded && (
                        <>
                            <thead>
                                <tr>
                                    <TableHeader onClick={() => handleSort('type')}>Employee Type {sortColumn === 'type' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('isActive')}> Active{sortColumn === 'nationalityCode' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                    <TableHeader onClick={() => handleSort('isDefault')}>Default {sortColumn === 'nationalityCode' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>

                                    <TableHeader>Actions</TableHeader>

                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((location, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{location.type}</TableCell>
                                        <TableCell>{location.isActive ? "Yes" : "No"}</TableCell>
                                        <TableCell>{location.isDefault ? "Yes" : "No"}</TableCell>
                                        <TableCell>
                                            <IconWrapper onClick={() => handleEdit(location)}>
                                                <FiEdit />
                                            </IconWrapper>
                                            <IconWrapper onClick={() => handleDelete(location)}>
                                                <FiTrash2 />
                                            </IconWrapper>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </>
                    )}
                </StyledTable>
                {isExpanded && (
                    <>
                        <PaginationContainer>
                            <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                                Previous
                            </PaginationButton>

                            <DropdownSelect value={currentPage} onChange={handlePageChange}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        Page {i + 1}
                                    </option>
                                ))}
                            </DropdownSelect>

                            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                                Next
                            </PaginationButton>
                        </PaginationContainer>
                    </>
                )}
                {isPopupVisibleCreate && (
                    <Popup>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0, color: '#293495' }}>Add Employee Type</h3>
                            <FiX
                                style={{ cursor: 'pointer' }}
                                size={20}
                                onClick={() => setIsPopupVisibleCreate(false)}
                            />
                        </div>
                        <LabelValueContainer>
                            <Label>Employee Type:</Label>
                            <Value><Input
                                type="text"
                                placeholder="Enter Employee type"
                                value={locationName}
                                onChange={(e) => setLocationName(e.target.value)}
                            /></Value>
                        </LabelValueContainer>
                        <LabelValueContainer>
                            <Label>Active:</Label>
                            <Value>
                                <input
                                    type="checkbox"
                                    checked={isActive}
                                    onChange={() => setIsActive(!isActive)}
                                />
                            </Value>
                        </LabelValueContainer>

                        <LabelValueContainer>
                            <Label>Default:</Label>
                            <Value>
                                <input
                                    type="checkbox"
                                    checked={isDefault}
                                    onChange={() => setIsDefault(!isDefault)}
                                />
                            </Value>
                        </LabelValueContainer>
                        <ButtonContainer>
                            <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
                            <PopupButton onClick={handleLocationSubmit}>Submit</PopupButton>
                        </ButtonContainer>
                        {/* Show loader when loading */}
                    </Popup>
                )}
                {isPopupVisible && (
                    <Popup>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0, color: '#293495' }}>Update Employee Type</h3>
                            <FiX
                                style={{ cursor: 'pointer' }}
                                size={20}
                                onClick={() => setIsPopupVisible(false)}
                            />
                        </div>
                        <LabelValueContainer>
                            <Label>Employee Type:</Label>
                            <Value><Input
                                type="text"
                                name="locationUpdate"
                                value={locationNameUpdate}
                                onChange={(e) => setLocationNameUpdate(e.target.value)}
                                placeholder="Enter Employee Type"
                            /></Value>
                        </LabelValueContainer>



                        <LabelValueContainer>
                            <Label>Active:</Label>
                            <Value>
                                <input
                                    type="checkbox"
                                    checked={isActiveUpdate}
                                    onChange={(e) => setIsActiveUpdate(e.target.checked)}
                                />
                            </Value>
                        </LabelValueContainer>

                        <LabelValueContainer>
                            <Label>Default:</Label>
                            <Value>
                                <input
                                    type="checkbox"
                                    checked={isDefaultUpdate}
                                    onChange={(e) => setIsDefaultUpdate(e.target.checked)}
                                />
                            </Value>
                        </LabelValueContainer>
                        <ButtonContainer>
                            <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                            <PopupButton onClick={handleSubmitUpdate}>Update</PopupButton>
                        </ButtonContainer>
                        {/* Show loader when loading */}
                    </Popup>
                )}

            </TableContainer>
            <ToastContainer />

        </Container>
    );
};

export default AddEmpTypePage;
